import { ethers } from 'ethers'
import { ArpeggiSupportedChain } from '../types'

/**
 * Consult this for chainnames:
 * https://docs.ethers.org/v5/api/providers/api-providers/
 */
export const PROD_CHAIN_NAMES: Record<ArpeggiSupportedChain, ethers.providers.Networkish> = {
  ethereum: 'homestead',
  polygon: 'matic',
  optimism: 'optimism'
}

export const DEV_CHAIN_NAMES: Record<ArpeggiSupportedChain, ethers.providers.Networkish> = {
  ethereum: 'goerli',
  polygon: 'maticmum',
  optimism: 'optimism-goerli'
}
